import { UtilityOptions } from "@opengov/components-nav-bar";

export const getNotificationsOptions = (notificationsCount: number, onIconClick: () => void): UtilityOptions => {
  return {
    menuSections: [],
    badgeVariant: "standard",
    ...(notificationsCount > 0 && { badgeContent: notificationsCount }),
    iconOnClickOverride: onIconClick,
  };
};
